<template>
  <div>
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Нэг хуудсанд</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label> бичлэг харуулах</label>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refReportDataTable"
        :items="fetchDailyReportData"
        :fields="tableColumns"
        responsive
        show-empty
        empty-text="Мэдээлэл олдсонгүй"
        bordered
      >
        <template #thead-top>
          <b-tr>
            <b-th
              colspan="2"
              class="text-center"
            />
            <b-th
              colspan="6"
              class="text-center"
            >
              Өдөр тутмын баримт
            </b-th>
            <b-th
              colspan="6"
              class="text-center"
            >
              Сарын баримт (тухайн өдөр илгээсэн)
            </b-th>
          </b-tr>
        </template>

        <template #cell(index)="data">
          {{ perPage * (currentPage - 1) + data.index + 1 }}
        </template>

        <template #cell(total_amount)="data">
          {{ formatCurrency(data.item.total_amount) }}
        </template>

        <template #cell(success_amount)="data">
          {{ formatCurrency(data.item.success_amount) }}
        </template>

        <template #cell(error_amount)="data">
          {{ formatCurrency(data.item.error_amount) }}
        </template>

        <template #cell(month_end_success_amount)="data">
          {{ formatCurrency(data.item.month_end_success_amount) }}
        </template>

        <template #cell(month_end_error_amount)="data">
          {{ formatCurrency(data.item.month_end_error_amount) }}
        </template>

        <template #cell(month_end_pending_amount)="data">
          {{ formatCurrency(data.item.month_end_pending_amount) }}
        </template>
      </b-table>

      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Нийт {{ dataMeta.of }}-н {{ dataMeta.from }} - {{ dataMeta.to }} бичлэгийг харуулж байна</span>
          </b-col>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BTable, BPagination, BTr, BTh,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import {
  ref, computed, watch, onUnmounted,
} from '@vue/composition-api'
import { formatCurrency } from '@core/utils/filter'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import loanEbarimtStoreModule from '../loanEbarimtStoreModule'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BPagination,
    BTr,
    BTh,
    vSelect,
  },
  setup() {
    const toast = useToast()
    const LOAN_EBARIMT_APP_STORE_MODULE_NAME = 'app-loan-ebarimt'

    if (!store.hasModule(LOAN_EBARIMT_APP_STORE_MODULE_NAME)) store.registerModule(LOAN_EBARIMT_APP_STORE_MODULE_NAME, loanEbarimtStoreModule)

    onUnmounted(() => {
      if (store.hasModule(LOAN_EBARIMT_APP_STORE_MODULE_NAME)) store.unregisterModule(LOAN_EBARIMT_APP_STORE_MODULE_NAME)
    })

    const tableColumns = [
      { key: 'index', label: '№' },
      {
        key: 'date', label: 'Огноо', thStyle: { width: '120px' }, tdClass: 'text-nowrap',
      },
      { key: 'success_count', label: 'Шивэгдсэн баримтын тоо' },
      { key: 'success_amount', label: 'Шивэгдсэн дүн' },
      { key: 'error_count', label: 'Шивэгдээгүй баримтын тоо' },
      { key: 'error_amount', label: 'Шивэгдээгүй дүн' },
      { key: 'total_count', label: 'Нийт баримтын тоо' },
      { key: 'total_amount', label: 'Нийт дүн' },
      // Сарын (MONTH_END) баримт нэг өдөрт багтахгүй — өдөр тутмын job өдрийн баримтын дараа үргэлжлүүлж илгээнэ
      { key: 'month_end_success_count', label: 'Шивэгдсэн баримтын тоо' },
      { key: 'month_end_success_amount', label: 'Шивэгдсэн дүн' },
      { key: 'month_end_error_count', label: 'Шивэгдээгүй баримтын тоо' },
      { key: 'month_end_error_amount', label: 'Шивэгдээгүй дүн' },
      { key: 'month_end_pending_count', label: 'Үлдсэн баримтын тоо' },
      { key: 'month_end_pending_amount', label: 'Үлдсэн дүн' },
    ]

    const refReportDataTable = ref(null)
    const perPage = ref(10)
    const perPageOptions = [10, 25, 50, 100]
    const currentPage = ref(1)
    const totalRows = ref(0)

    const dataMeta = computed(() => {
      const localItemsCount = refReportDataTable.value ? refReportDataTable.value.localItems.length : 0
      return {
        from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: totalRows.value,
      }
    })

    const refetchData = () => {
      refReportDataTable.value.refresh()
    }

    watch([currentPage, perPage], () => {
      refetchData()
    })

    const fetchDailyReportData = (ctx, callback) => {
      store
        .dispatch('app-loan-ebarimt/fetchLoanEbarimtDailyReport', {
          limit: perPage.value,
          offset: perPage.value * (currentPage.value - 1),
        })
        .then(response => {
          const { rows, total } = response.data
          callback(rows)
          totalRows.value = total
        })
        .catch(() => {
          callback([])
          toast({
            component: ToastificationContent,
            props: {
              title: 'Тайлан татахад алдаа гарлаа',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }

    return {
      tableColumns,
      refReportDataTable,
      perPage,
      perPageOptions,
      currentPage,
      totalRows,
      dataMeta,
      fetchDailyReportData,
      formatCurrency,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
